var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"multi-select-filter"},[_c('sk-multiselect',{attrs:{"items-list":_vm.selectList,"preselected-value":_vm.selectedOptions,"default-value":_vm.placeholder},on:{"checkboxeschanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }